// const COMMON = "http://localhost:1245/";
// const COMMON = "http://65.1.114.66:1250/";
const COMMON = "https://api.thriftyx.com/";

const routes = Object.freeze({
    USER: COMMON + 'admin/user',
    LOGIN: COMMON + "admin/login",
    EVENT: COMMON + "admin/event",
    ORDER: COMMON + "admin/order",
    REVIEW: COMMON + "main/review",
    FOUNDER: COMMON + "main/founder",
    PARTNER: COMMON + "main/partner",
    GET_EVENT: COMMON + "main/event",
    GALLERY: COMMON + "main/gallery",
    AD_REVIEW: COMMON + "admin/review",
    REGISTER: COMMON + "admin/register",
    AD_FOUNDER: COMMON + "admin/founder",
    AD_PARTNER: COMMON + "admin/partner",
    SUB_ADMIN: COMMON + "admin/sub-admin",
    GALLERY_ADMIN: COMMON + "admin/gallery",
    UPLOAD_ON_S3: COMMON + "main/upload_on_s3",
    QUESTION: COMMON + "admin/question-answer",
    ORDER_TICKET: COMMON + "admin/order-ticket",
    GET_CONTACT_US: COMMON + "admin/contact-us",
    VERIFY_TOKEN: COMMON + "admin/verify-token",
    GET_QUESTIONS: COMMON + "main/question-answer",
    GET_HEADER_IMAGE: COMMON + "main/header-image",
    ADD_HEADER_IMAGE: COMMON + "admin/header-image",
});
export default routes;